import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {DIMENSION_PRINT_2D_WIDTH} from '../../../../shared/tools';


/**
 * permet de charger l'image d'un module-custom en respectant le ratio print/canvas
 */
@Component({
  selector: 'custom-img',
  template: `
      <img #img [src]="entity.url" alt="Custom Block" [width]="width">
      @if (!isLoaded) {
        <div class="img-loading">Chargement de l'image...</div>
      }
  `,
  styles: [`
    .img-loading {
      background: white;
      padding: 5px;
      border-radius: 5px;
    }
  `],
  standalone: true,
})
export class ModuleCustomImgComponent implements AfterViewInit {

  @ViewChild('img') img: ElementRef<HTMLImageElement>;

  @Input() containerDimension: { width: number; height: number };
  @Input() entity: any;

  isLoaded = false;
  width = 0;

  ngAfterViewInit(): void {
    this.img.nativeElement.onload = () => {
      this.isLoaded = true;
      const imgWidth = this.img.nativeElement.naturalWidth;
      const renderedCanvasWidth = this.containerDimension.width;
      const scaleX = renderedCanvasWidth / DIMENSION_PRINT_2D_WIDTH;
      this.width = imgWidth * scaleX;
    };
  }
}
